var exports = {
  "kL": "x2b2fbebb--460362--container",
  "y0": "x2b2fbebb--460362--container--popup",
  "HU": "x2b2fbebb--460362--aside",
  "iW": "x2b2fbebb--460362--main",
  "cy": "x2b2fbebb--460362--author",
  "n2": "x2b2fbebb--460362--main-heading",
};

module.exports = exports;
